export default "__VITE_ASSET__B2aHE3Qr__"